<template>
  <!-- Origem Flow: documentos e quadros vinculados a esta tarefa. -->
  <div v-if="documents.length || whiteboards.length" class="row-linked-documents">
    <div class="row-linked-documents__title">
      <i class="iconoir-page"></i>
      {{ $t('rowLinkedDocuments.title') }}
    </div>
    <a
      v-for="document in documents"
      :key="'doc-' + document.id"
      class="row-linked-documents__item"
      @click="openDocument(document)"
    >
      <i class="iconoir-page row-linked-documents__item-icon"></i>
      {{ document.name || $t('docsHub.untitled') }}
    </a>
    <a
      v-for="whiteboard in whiteboards"
      :key="'board-' + whiteboard.id"
      class="row-linked-documents__item"
      @click="openWhiteboard(whiteboard)"
    >
      <i class="iconoir-design-pencil row-linked-documents__item-icon"></i>
      {{ whiteboard.name || $t('whiteboardsHub.untitled') }}
    </a>
  </div>
</template>

<script>
import DocsService from '@baserow/modules/core/services/docs'
import WhiteboardsService from '@baserow/modules/core/services/whiteboards'

export default {
  name: 'RowLinkedDocuments',
  props: {
    database: {
      type: Object,
      required: true,
    },
    table: {
      type: Object,
      required: true,
    },
    row: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      documents: [],
      whiteboards: [],
    }
  },
  watch: {
    'row.id': {
      handler() {
        this.fetchDocuments()
      },
      immediate: true,
    },
  },
  methods: {
    async fetchDocuments() {
      this.documents = []
      this.whiteboards = []
      if (!this.row?.id || !this.database.workspace?.id) {
        return
      }
      const filters = { tableId: this.table.id, rowId: this.row.id }
      try {
        const [docsResponse, boardsResponse] = await Promise.all([
          DocsService(this.$client).fetchAll(
            this.database.workspace.id,
            filters
          ),
          WhiteboardsService(this.$client).fetchAll(
            this.database.workspace.id,
            filters
          ),
        ])
        this.documents = docsResponse.data.documents
        this.whiteboards = boardsResponse.data.whiteboards
      } catch (error) {
        // Seção opcional: sem itens vinculados em caso de erro.
        this.documents = []
        this.whiteboards = []
      }
    },
    openWhiteboard(whiteboard) {
      this.$router.push({
        name: 'workspace-whiteboards',
        params: { workspaceId: this.database.workspace.id },
        query: { board: whiteboard.id },
      })
    },
    openDocument(document) {
      this.$router.push({
        name: 'workspace-docs',
        params: { workspaceId: this.database.workspace.id },
        query: { doc: document.id },
      })
    },
  },
}
</script>
